//Calculate windows width and height
function viewport() {
  return { width: window.innerWidth, height: window.innerHeight };
}

//Find biggest element
function getBiggestHeight(array) {
  let maxHeight = 0;

  array.forEach(target => {
    const targetHeight = target.offsetHeight;
    if (targetHeight > maxHeight) {
      maxHeight = targetHeight;
    }
  });

  return maxHeight;
}

//Remove class
function replaceCSSClass(element, oldClassName, newClassName) {
  // Iterate through all classes of the element
  element.classList.forEach(className => {
    // If the class starts with oldClassName, remove it
    if (className.startsWith(oldClassName)) {
      element.classList.remove(className);
      element.classList.add(newClassName);
    }
  });
}

//Close the item when clicking outside
function clickOutside() {
  /*

    Attach attribute data-close-container="identifier" to the element outside which you want to the click to register
    attach attribute data-close-target="identifier" to the element you want to close, attach data-close-class="class-name" to the [data-close-container] element and define the class you want to remove from [data-close-target] element upon clicking outside the [data-close-container]. Class name defaults to 'is-visible'
  */
  'use strict';

  // Add event listener to the whole body
  document.body.addEventListener('click', function (event) {
    // Select all elements with the attribute `data-close-container`
    document.querySelectorAll('[data-close-container]').forEach(function (closeContainer) {
      const closeTargetAttr = closeContainer.getAttribute('data-close-container');
      const closeTarget = document.querySelector(`[data-close-target="${closeTargetAttr}"]`);
      const closeClass = closeContainer.getAttribute('data-close-class') || 'is-visible';

      // Check if the click is outside of the closeContainer
      if (!closeContainer.contains(event.target) && closeContainer !== event.target) {
        closeTarget.classList.remove(closeClass);
      }
    });
  });
}

//Reset animation
function resetAnimation(img) {
  const newImg = new Image();
  newImg.src = img.src;
  newImg.onload = () => (img.src = newImg.src);
}

function resetAnimationSafari(img) {
  fetch(img.src)
    .then(response => response.blob())
    .then(blob => {
      const objectURL = URL.createObjectURL(blob);
      img.src = '';
      void img.offsetWidth;
      img.src = objectURL;
    });
}

function isSafari() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('safari') && !userAgent.includes('chrome');
}

document.addEventListener('DOMContentLoaded', function (e) {
  //Open / Close Navigation
  const mainNav = document.querySelector('nav');
  const menuTrigger = document.querySelector('.mobile-menu-trigger');
  menuTrigger.addEventListener('click', () => {
    mainNav.classList.toggle('mob-menu-is-active');
  });
  
  //Start Testimonial Carousel
  const testimonials = document.querySelector('.testimonials');
  setTimeout(() => {
    testimonials.classList.add('is-running');
  }, 4000);

  //Open / Close Modals
  const modalWrapper = document.querySelector('.modal-wrapper');
  const modalTriggers = modalWrapper.querySelectorAll('.modal-trigger');
  modalWrapper.addEventListener('click', (e) => {
    const target = e.target;
    if (target.matches('.modal-trigger')) {
      modalTriggers.forEach((btn) => {
        //Prevent modal trigger flashing
        if (btn !== target && !btn.classList.contains('is-clicked')) {
          btn.classList.add('not-clicked');
        }
      });
      target.classList.toggle('is-clicked');
      target.classList.remove('not-clicked');

    }
    else if (target.matches('.modal-overlay')) {
      document.querySelector('.modal-trigger.is-clicked').classList.remove('is-clicked');
    }
  });

  //Close the item when clicking outside
  clickOutside();

});

document.addEventListener('DOMContentLoaded', function (e) {
  const figWomanContainer = document.querySelector('.fig-woman');
  let scrollDirection;
  let oldScrollY = window.scrollY;
  let onLoad = true;
  let vpHeight = viewport().height;
  const pi2ProbImg = document.querySelector('.pi-to-prob-fig');
  const prob2SolImg = document.querySelector('.prob-to-sol-fig');
  const prob2PiImg = document.querySelector('.prob-to-pi-fig');
  const sol2ProbImg = document.querySelector('.sol-to-prob-fig');
  const isSaf = isSafari();

  //Remove transition on load
  if (onLoad) {
    document.body.classList.add('on-load');
    onLoad = false;
    setTimeout(() => {
      document.body.classList.remove('on-load');
    }, 700);
  }

  //Check scroll direction
  window.onscroll = function (e) {
    scrollDirection = oldScrollY < window.scrollY ? 'down' : 'up';
    oldScrollY = window.scrollY;
  };

  //Handle woman figure visibility
  function handleIntersection(entries) {
    const homeHero = document.querySelector('#home-hero');
    const homeProblem = document.querySelector('#home-problem');
    const homeSolution = document.querySelector('#home-solution');

    const showTransition = (className, delay = 1000) => {
      figWomanContainer.classList.add(className);
      setTimeout(() => {
        figWomanContainer.classList.remove(className);
      }, delay);
    };

    const handleScrollDown = () => {
      if (homeHero.classList.contains('is-visible') && homeProblem.classList.contains('is-visible')) {
        // Show pi to prob;
        if (isSaf) {
          resetAnimationSafari(pi2ProbImg);
        } else {
          resetAnimation(pi2ProbImg);
        }
        showTransition('show-pi-to-prob');
      } else if (homeProblem.classList.contains('is-visible') && homeSolution.classList.contains('is-visible')) {
        // Show prob to sol
        if (isSaf) {
          resetAnimationSafari(prob2SolImg);
        } else {
          resetAnimation(prob2SolImg);
        }
        showTransition('show-prob-to-sol', 1100);
      }
    };

    const handleScrollUp = () => {
      if (homeHero.classList.contains('is-visible') && !homeProblem.classList.contains('is-visible') && oldScrollY !== 0) {
        // Show prob to pi
        if (isSaf) {
          resetAnimationSafari(prob2PiImg);
        } else {
          resetAnimation(prob2PiImg);
        }
        showTransition('show-prob-to-pi');
      } else if (homeProblem.classList.contains('is-visible') && !homeSolution.classList.contains('is-visible')) {
        // Show sol to prob
        if (isSaf) {
          resetAnimationSafari(sol2ProbImg);
        } else {
          resetAnimation(sol2ProbImg);
        }
        showTransition('show-sol-to-prob', 1500);
      }
    };

    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) {
        target.classList.add('is-visible');
        if (scrollDirection === 'down') {
          handleScrollDown();
        }
      } else {
        target.classList.remove('is-visible');
        if (scrollDirection === 'up') {
          handleScrollUp();
        }
      }
    });
  }

  const thresholdValue = vpHeight <= 800 ? 0.1 : 0.3;
  const observerOptions = { threshold: thresholdValue };
  const observer = new IntersectionObserver(handleIntersection, observerOptions);

  document.querySelectorAll('.group').forEach(section => {
    observer.observe(section);
  });

  //Handle figure woman top position
  function getElementDistanceFromTop(elementID) {
    const element = document.getElementById(elementID);
    return element ? element.offsetTop : 0;
  }

  // Create or update the <style> tag
  let style =
    document.querySelector('#fixed-styles') ||
    (() => {
      let s = document.createElement('style');
      s.id = 'fixed-styles';
      document.head.appendChild(s);
      return s;
    })();

  function updateFixedStyles() {
    const problemDistance = getElementDistanceFromTop('home-problem');
    const solutionDistance = getElementDistanceFromTop('home-solution');

    // Define CSS rules with dynamic values
    const css = `
        body:has(#home-problem.is-visible):not(:has(#home-solution.is-visible)) .fig-woman {
          top: calc(${problemDistance}px + 200px);
        }
        body:has(#home-solution.is-visible):not(:has(#home-product.is-visible)) .fig-woman,
        body:has(#home-product.is-visible) .fig-woman {
          top: calc(${solutionDistance}px + 90px);
        }
      `;

    style.textContent = css;
  }

  // Initial update of styles
  setTimeout(updateFixedStyles, 400);
  updateFixedStyles();

  // Update styles if the window is resized
  window.addEventListener('resize', updateFixedStyles);

  //Handle content visibility
  function handleContentIntersection(entries) {
    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) {
        target.classList.add('is-visible');
      } else {
        target.classList.remove('is-visible');
      }
    });
  }
  const contentObserverOptions = { threshold: 0.2 };
  const contentObserver = new IntersectionObserver(handleContentIntersection, contentObserverOptions);
  document.querySelectorAll('.group .container').forEach(container => {
    contentObserver.observe(container);
  });
});

document.addEventListener('DOMContentLoaded', function () {

  /////////////////////////////////////////////////////////////////////////
  // 1. Helper functions to encode & submit data to Netlify (AJAX)
  /////////////////////////////////////////////////////////////////////////
  function encodeFormData(dataObj = {}) {
    return Object.keys(dataObj)
      .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(dataObj[key]))
      .join("&");
  }

  function submitToNetlify(formDataObj) {
    // This sends a background POST to Netlify. 
    // Netlify sees the form fields & triggers the usual "form submission email."
    return fetch("/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: encodeFormData(formDataObj)
    });
  }

  /////////////////////////////////////////////////////////////////////////
  // 2. Main quiz initialization
  /////////////////////////////////////////////////////////////////////////
  function initializeQuiz() {
    // 2a. All your normal variable declarations, including the 0-initialized shield values
    let vpWidth = viewport().width;
    const q2AImg = document.querySelector('.figure-q-to-a');
    const q2A2qImg = document.querySelector('.figure-q-to-a-to-q');
    const quiz = document.querySelector('#section-quiz');
    const quizContent = document.querySelector('#section-quiz .content');
    const quizContentSubtitle = quizContent.querySelector('.subtitle');
    const quizContentSubtitleMarginBtm = quizContentSubtitle
      ? parseInt(getComputedStyle(quizContentSubtitle).marginBottom)
      : 0;
    const quizContentTitle = quizContent.querySelector('h2');
    const quizDialogContainer = document.querySelector('.quiz-dialog-container');
    const stepTriggers = document.querySelectorAll('[data-step-trigger]');
    const lastStepTrigger = stepTriggers[stepTriggers.length - 1].dataset.stepTrigger;
    const secondToLastStepTrigger = stepTriggers[stepTriggers.length - 2].dataset.stepTrigger;
    const stepTargets = document.querySelectorAll('.quiz-step');
    const quizSteps = document.querySelector('.quiz-steps');
    const firstQuestion = document.querySelector('.quiz-question-step-1');
    const startQuestionMarginBottomMobile = 150;
    const startQuestionPaddingTopMobile = 24;
    const questionMarginBottom = 26;
    const questionPadding = 40;
    const resultField = document.querySelector('#result'); // the hidden "Recommended Shield" field
    let customTerm = '';
    let customTitle = '';
    let customLead = '';
    const questionCustomTerm = document.querySelector('.custom-term');
    const downloadBoxTitle = document.querySelector('.download-box-title');
    const downloadBoxLead = document.querySelector('.download-box-lead');
    const isSaf = isSafari();

    // Initialize shield variables
    let noPersonalShield = 0;
    let level2BioelectricShield = 0;
    let level2ShieldWithFocusing = 0;
    let level3BioelectricShield = 0;
    let level3ShieldWithFocusing = 0;
    let level4BioelectricShield = 0;
    let level4ShieldWithFocusing = 0;
    let highestScore;
    let highestScoringVariable;

    /////////////////////////////////////////////////////////////////////////
    // 2b. We'll store each step's answers in an object
    /////////////////////////////////////////////////////////////////////////
    const quizData = {};

    /////////////////////////////////////////////////////////////////////////
    // 2c. The function that updates shield values based on each answer
    /////////////////////////////////////////////////////////////////////////
    function updateShieldValues(answer) {
      switch (answer) {
        case 'q-1-a':
        case 'q-2-a':
        case 'q-3-a':
        case 'q-4-a':
        case 'q-5-a':
        case 'q-6-a':
        case 'q-9-a':
          noPersonalShield += 5;
          level2BioelectricShield += 3;
          level2ShieldWithFocusing += 3;
          break;

        case 'q-1-b':
        case 'q-2-b':
        case 'q-3-b':
        case 'q-4-b':
        case 'q-5-b':
        case 'q-6-b':
        case 'q-9-b':
          level2BioelectricShield += 5;
          level2ShieldWithFocusing += 5;
          level3BioelectricShield += 5;
          level3ShieldWithFocusing += 5;
          break;

        case 'q-1-c':
        case 'q-2-c':
        case 'q-3-c':
        case 'q-4-c':
        case 'q-5-c':
        case 'q-6-c':
        case 'q-9-c':
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          break;

        case 'q-1-d':
        case 'q-2-d':
        case 'q-3-d':
        case 'q-4-d':
        case 'q-5-d':
        case 'q-6-d':
        case 'q-9-d':
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-7-a':
        case 'q-7-b':
        case 'q-7-c':
        case 'q-7-d':
          // noPersonalShield += 0;
          break;

        case 'q-8-a':
        case 'q-8-b':
        case 'q-8-d':
        case 'q-8-f':
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-8-c':
          level2BioelectricShield += 4;
          level2ShieldWithFocusing += 4;
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-8-e':
          level2BioelectricShield += 5;
          level2ShieldWithFocusing += 5;
          level3BioelectricShield += 10;
          level3ShieldWithFocusing += 10;
          level4BioelectricShield += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-9-a':
          noPersonalShield += 5;
          level2BioelectricShield += 2;
          level2ShieldWithFocusing += 2;
          break;

        case 'q-10-a':
          level2ShieldWithFocusing += 10;
          level3ShieldWithFocusing += 10;
          level4ShieldWithFocusing += 10;
          break;

        case 'q-10-b':
          level2ShieldWithFocusing -= 1;
          level3ShieldWithFocusing -= 1;
          level4ShieldWithFocusing -= 1;
          break;

        default:
          break;
      }
    }

    /////////////////////////////////////////////////////////////////////////
    // 2d. Shopify subscription 
    /////////////////////////////////////////////////////////////////////////
    function subscribeToShopifyNewsletter(email) {
      console.log("Subscribing with email:", email);
      const shopifyApiUrl = '/.netlify/functions/subscribe'; // make sure this URL is correct
      const payload = { email };
    
      return fetch(shopifyApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      })
      .then((response) => {
        if (response.ok) {
          console.log('Newsletter subscription successful');
        } else {
          console.error('Error subscribing to newsletter');
        }
        return response;
      })
      .catch((error) => {
        console.error('Error subscribing to newsletter:', error);
        throw error;
      });
    }

    /////////////////////////////////////////////////////////////////////////
    // 2e. Open recommended PDF in new tab
    /////////////////////////////////////////////////////////////////////////
    function downloadPDF(recommendedLevel) {
      const pdfMap = {
        'No Personal Shield': 'no_personal_shield.pdf',
        'Level 2 BioElectric Shield': 'BioElectricShield_Level_2_Recommendation.pdf',
        'Level 2 Shield with Focusing': 'BioElectricShield_Level_2_with_focusing_Recommendation.pdf',
        'Level 3 BioElectric Shield': 'BioElectricShield_Level_3_Recommendation.pdf',
        'Level 3 Shield with Focusing': 'BioElectricShield_Level_3_with_focusing_Recommendation.pdf',
        'Level 4 BioElectric Shield': 'BioElectricShield_Level_4_Recommendation.pdf',
        'Level 4 Shield with Focusing': 'BioElectricShield_Level_4_with_focusing_Recommendation.pdf',
      };
      const pdfFile = pdfMap[recommendedLevel];
      if (pdfFile) {
        const pdfUrl = `https://static.bioelectricshield.com/pdf/${pdfFile}`;
        window.open(pdfUrl, '_blank');
      } else {
        console.error('No PDF file mapped for:', recommendedLevel);
      }
    }

    /////////////////////////////////////////////////////////////////////////
    // 2f. Helper functions for animations and viewport
    /////////////////////////////////////////////////////////////////////////
    function viewport() {
      const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      return { width: width, height: height };
    }

    function replaceCSSClass(element, prefix, newClass) {
      const classes = element.className.split(' ').filter((c) => !c.startsWith(prefix));
      classes.push(newClass);
      element.className = classes.join(' ');
    }

    function isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    function getBiggestHeight(elements) {
      let maxHeight = 0;
      elements.forEach((element) => {
        const height = element.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      return maxHeight;
    }

    function resetAnimation(el) {
      el.style.animation = 'none';
      el.offsetHeight; /* trigger reflow */
      el.style.animation = null;
    }

    function resetAnimationSafari(el) {
      el.style.webkitAnimation = 'none';
      el.offsetHeight; /* trigger reflow */
      el.style.webkitAnimation = null;
    }

    /////////////////////////////////////////////////////////////////////////
    // 3. Main logic: steps, answer selection, final submission
    /////////////////////////////////////////////////////////////////////////
    if (stepTriggers && stepTargets && quizSteps) {

      // 3a. We set up an object for each step so we know if it has radio or checkboxes
      stepTargets.forEach((step) => {
        const stepNumber = step.dataset.step;
        const isRadio = step.querySelector('input[type="radio"]') !== null;
        const isCheckbox = step.querySelector('input[type="checkbox"]') !== null;

        if (isRadio) {
          quizData[stepNumber] = { value: '', label: '' };
        }
        if (isCheckbox) {
          quizData[stepNumber] = { values: [], labels: [] };
        }
      });

      // For fancy figure animations
      const animatedSteps = Object.keys(quizData).filter((step) => step !== 'step-1');

      // 3b. Set the quiz's container height to whichever step is tallest
      function setQuizHeight() {
        const biggestHeight = getBiggestHeight(stepTargets);
        quizSteps.style.height = `${biggestHeight}px`;
      }

      document.fonts.ready.then(function () {
        // Position first question bubble
        const firstQuestionHeight =
          firstQuestion.querySelector('p').offsetHeight +
          firstQuestion.querySelector('span').offsetHeight +
          questionPadding;
        const initialFirstQuestionPosition = firstQuestion
          ? (firstQuestionHeight + questionMarginBottom) / 2
          : 0;

        quizDialogContainer.style.paddingTop = `${initialFirstQuestionPosition}px`;

        stepTargets.forEach((step) => {
          if (!step.classList.contains('quiz-start')) {
            step.querySelector('.content').style.paddingTop =
              `${initialFirstQuestionPosition * 2}px`;
          }
        });

        // On desktop, set quiz container height
        // On mobile, handle differently
        if (vpWidth < 640) {
          if (quizSteps.dataset.step === 'step-0') {
            quizSteps.style.height = `${
              document.querySelector('.quiz-start .button-wrapper').offsetHeight +
              document.querySelector('.quiz-start .speech-bubble p').offsetHeight +
              questionPadding +
              startQuestionMarginBottomMobile +
              startQuestionPaddingTopMobile
            }px`;
            quizContent.style.height = `${
              quizContentSubtitle.offsetHeight +
              quizContentTitle.offsetHeight +
              quizContentSubtitleMarginBtm
            }px`;
          }
        } else {
          setQuizHeight();
        }
      });

      window.addEventListener('resize', () => {
        vpWidth = viewport().width;
        if (vpWidth < 640) {
          if (quizSteps.dataset.step === 'step-0') {
            quizSteps.style.height = `${document.querySelector('.quiz-start').offsetHeight}px`;
            quizContent.style.height = `${
              quizContentSubtitle.offsetHeight +
              quizContentTitle.offsetHeight +
              quizContentSubtitleMarginBtm
            }px`;
          } else {
            quizContent.style.height = 0;
          }
        } else {
          quizContent.style.height = 'auto';
          setQuizHeight();
        }
      });

      // 3c. Step transition click handler
      quizSteps.addEventListener('click', (e) => {
        e.stopPropagation();

        if (e.target.matches('[data-step-trigger]')) {
          e.preventDefault();
          const trigger = e.target;
          const triggerTarget = quizSteps; 
          const targetIdentifier = trigger.dataset.stepTrigger;
          const currentStep = triggerTarget.dataset.step;
          const nextTrigger = document.querySelector(`.quiz-${targetIdentifier} [data-step-trigger]`);

          if (vpWidth < 640) {
            const nextStepElem = document.querySelector(`.quiz-${targetIdentifier}`);
            if (nextStepElem) {
              quizSteps.style.height = nextStepElem.offsetHeight + "px";
            }
          }

          const stepAnswer = document.querySelector(`.quiz-answer-${currentStep}`);
          const currentQuestion = document.querySelector(`.quiz-question-${currentStep}`);
          const nextQuestion = document.querySelector(`.quiz-question-${targetIdentifier}`);
          const currentPosition = firstQuestion 
            ? parseInt(getComputedStyle(firstQuestion).marginTop) * -1 
            : 0;
          const initialMovementDistance = stepAnswer 
            ? (stepAnswer.offsetHeight + questionMarginBottom) 
            : 0;
          const secondMovementDistance = nextQuestion 
            ? (nextQuestion.offsetHeight + questionMarginBottom) 
            : 0;

          triggerTarget.dataset.step = targetIdentifier;
          replaceCSSClass(quiz, 'is-step', `is-${targetIdentifier}`);

          // On mobile, hide quiz content if going to step-1
          if (vpWidth < 640 && targetIdentifier == 'step-1') {
            quizContent.style.height = '0px';
          }

          if (stepAnswer) {
            // Move from old question to new
            firstQuestion.style.marginTop = `-${initialMovementDistance + currentPosition}px`;

            // Figure animations
            if ([...animatedSteps, secondToLastStepTrigger].includes(targetIdentifier)) {
              quiz.classList.remove('show-q');
              if (isSaf) resetAnimationSafari(q2A2qImg);
              else resetAnimation(q2A2qImg);

              quiz.classList.add('show-q-to-a-to-q');
              setTimeout(() => { quiz.classList.add('show-q'); }, 1100);

              setTimeout(() => {
                if (nextTrigger) nextTrigger.style.pointerEvents = 'auto';
              }, 1200);
            }
            else if (targetIdentifier == lastStepTrigger) {
              quiz.classList.remove('show-q-to-a-to-q');
              quiz.classList.remove('show-q');
              if (isSaf) resetAnimationSafari(q2AImg);
              else resetAnimation(q2AImg);

              quiz.classList.add('show-q-to-a');
              setTimeout(() => {
                quiz.classList.remove('show-q-to-a');
                quiz.classList.add('show-a');
              }, 500);
            }

            setTimeout(() => {
              const sum = initialMovementDistance + secondMovementDistance + currentPosition;
              firstQuestion.style.marginTop = `-${sum}px`;
              if (currentQuestion) currentQuestion.classList.add('is-blurred');
              if (stepAnswer) stepAnswer.classList.add('is-blurred');
            }, 500);

            // Step before last -> compute recommended shield
            if (targetIdentifier == secondToLastStepTrigger) {
              Object.keys(quizData).forEach((stepNo) => {
                if (quizData[stepNo].value) {
                  updateShieldValues(quizData[stepNo].value);
                }
                if (quizData[stepNo].values && quizData[stepNo].values.length > 0) {
                  quizData[stepNo].values.forEach((val) => updateShieldValues(val));
                }
              });

              // Tie-break logic
              highestScoringVariable = (() => {
                if (level3BioelectricShield === level4BioelectricShield) {
                  level4BioelectricShield = Math.max(level3BioelectricShield, level4BioelectricShield);
                }
                if (level3ShieldWithFocusing === level4ShieldWithFocusing) {
                  level4ShieldWithFocusing = Math.max(level3ShieldWithFocusing, level4ShieldWithFocusing);
                }
                if (level2BioelectricShield === level3BioelectricShield) {
                  level3BioelectricShield = Math.max(level2BioelectricShield, level3BioelectricShield);
                }
                if (level2ShieldWithFocusing === level3ShieldWithFocusing) {
                  level3ShieldWithFocusing = Math.max(level2ShieldWithFocusing, level3ShieldWithFocusing);
                }

                highestScore = Math.max(
                  noPersonalShield,
                  level2BioelectricShield,
                  level2ShieldWithFocusing,
                  level3BioelectricShield,
                  level3ShieldWithFocusing,
                  level4BioelectricShield,
                  level4ShieldWithFocusing
                );

                switch (highestScore) {
                  case noPersonalShield:              return 'No Personal Shield';
                  case level4BioelectricShield:       return 'Level 4 BioElectric Shield';
                  case level4ShieldWithFocusing:      return 'Level 4 Shield with Focusing';
                  case level3BioelectricShield:       return 'Level 3 BioElectric Shield';
                  case level3ShieldWithFocusing:      return 'Level 3 Shield with Focusing';
                  case level2BioelectricShield:       return 'Level 2 BioElectric Shield';
                  case level2ShieldWithFocusing:      return 'Level 2 Shield with Focusing';
                  default:                             return 'No highest scoring shield';
                }
              })();

              // Change text for question-step-11
              customTerm = 'inner harmony and overall well-being';
              if (questionCustomTerm) {
                questionCustomTerm.innerText = customTerm;
              }
            }
            // Last step => fill in final recommended text
            else if (targetIdentifier == lastStepTrigger) {
              const recommendationTexts = {
                'No Personal Shield': {
                  title: 'You might not need a personal shield right now!',
                  lead: 'Based on your answers, it seems you are not experiencing significant issues that require a personal shield.',
                  link: 'https://example.com/no-personal-shield',
                },
                'Level 2 BioElectric Shield': {
                  title: 'A Level 2 BioElectric Shield is recommended for you!',
                  lead: 'Our Level 2 Shield provides excellent protection and is suitable for your needs.',
                  link: '../categories/level-2-essential-plus',
                },
                'Level 2 Shield with Focusing': {
                  title: 'Consider a Level 2 Shield with Focusing!',
                  lead: 'This shield not only offers protection but also enhances focus.',
                  link: '../categories/focusing-level-2',
                },
                'Level 3 BioElectric Shield': {
                  title: 'We recommend a Level 3 BioElectric Shield!',
                  lead: 'For stronger protection, the Level 3 Shield is ideal based on your responses.',
                  link: '../categories/level-3-premium',
                },
                'Level 3 Shield with Focusing': {
                  title: 'A Level 3 Shield with Focusing is perfect for you!',
                  lead: 'Enhanced protection + focus match your needs.',
                  link: '../categories/focusing-level-3',
                },
                'Level 4 BioElectric Shield': {
                  title: 'A Level 4 BioElectric Shield is the best choice for you!',
                  lead: 'Our highest level of protection is recommended based on your answers.',
                  link: '../categories/level-4-ultimate',
                },
                'Level 4 Shield with Focusing': {
                  title: 'The Level 4 Shield with Focusing is highly recommended!',
                  lead: 'Maximum protection and enhanced focus align with your needs.',
                  link: '../categories/focusing-level-4',
                },
              };

              const recommendation = recommendationTexts[highestScoringVariable];
              if (recommendation) {
                customTitle = recommendation.title;
                customLead = recommendation.lead;
                const link = recommendation.link;
                const linkText = `View options for your ${highestScoringVariable}`;
                downloadBoxTitle.innerText = customTitle;
                downloadBoxLead.innerHTML = 
                  `${customLead} &nbsp;<a href="${link}" target="_blank">${linkText}</a>`;
              } else {
                customTitle = 'Based on your answers, we have a recommendation for you!';
                customLead = 'Learn how to shield yourself from disruptive energy and improve harmony.';
                downloadBoxTitle.innerText = customTitle;
                downloadBoxLead.innerHTML = customLead;
              }

              // Put final recommended shield into the hidden #result
              resultField.value = highestScoringVariable;

              // Adjust final step container height
              const finalStepEl = document.querySelector(`.quiz-${targetIdentifier}`);
              if (finalStepEl) {
                quizSteps.style.height = finalStepEl.offsetHeight + 'px';
              }
            }
          }
          else {
            // Fallback negative margin (from your older file)
            firstQuestion.style.marginTop = `-${
              (secondMovementDistance + currentPosition) / 2
            }px`;
          }
        }
        else if (
          e.target.tagName === 'INPUT' &&
          (e.target.type === 'radio' || e.target.type === 'checkbox')
        ) {
          // 3d. Handling user’s choice
          const target = e.target;
          const step = target.name; // e.g. "step-1"
          const value = target.value;
          const labelElement = document.querySelector(`label[for="${target.id}"] .choice-title`);
          const label = labelElement ? labelElement.innerText : '';
          const continueButton = document.querySelector(`.quiz-${step} .button`);
          const stepAnswer = document.querySelector(`.quiz-answer-${step}`);

          if (target.type === 'radio') {
            quizData[step].value = value;
            quizData[step].label = label;
            if (stepAnswer) {
              stepAnswer.innerText = label;
            }
          } else {
            // It's a checkbox question
            const i = quizData[step].values.indexOf(value);
            const j = quizData[step].labels.indexOf(label);

            if (i === -1) {
              quizData[step].values.push(value);
            } else {
              quizData[step].values.splice(i, 1);
            }

            if (j === -1) {
              quizData[step].labels.push(label);
            } else {
              quizData[step].labels.splice(j, 1);
            }

            if (stepAnswer) {
              stepAnswer.innerText = quizData[step].labels.join(', ');
            }
          }

          // Enable "Continue" if there's at least 1 selection
          if (continueButton) {
            continueButton.disabled = !(quizData[step].value || quizData[step].values.length > 0);
          }
        }
      });

      /////////////////////////////////////////////////////////////////////////
      // 3e. Final form submission (no reload), send to Netlify, etc.
      /////////////////////////////////////////////////////////////////////////
      const downloadForm = document.querySelector('form[name="download"]');
      if (downloadForm) {
        downloadForm.addEventListener('submit', async function (e) {
          console.log("Download form submit triggered");
          e.preventDefault(); // No page reload

          // 1) Grab the user’s email
          const emailInput = document.getElementById('email');
          const email = emailInput ? emailInput.value : "";

          // 2) Shopify subscription
          if (email) {
            await subscribeToShopifyNewsletter(email);
          }

          // 3) The recommended shield from #result
          const recommendedLevel = resultField.value;

          // 4) Open recommended PDF in new tab
          downloadPDF(recommendedLevel);

          // 5) Hide form, show "thank you" block
          downloadForm.style.display = 'none';
          document.getElementById('thank-you-message').style.display = 'block';

          // 6) Fill the hidden fields with user answers so Netlify sees them
          Object.keys(quizData).forEach((stepNumber) => {
            const stepData = quizData[stepNumber];
            const hiddenField = document.querySelector('#answer-' + stepNumber);
            if (!hiddenField) return;
            
            if (stepData.value) {
              // Radio single answer
              hiddenField.value = stepData.label;
            } 
            else if (stepData.values && stepData.values.length > 0) {
              // Checkbox multiple answers
              hiddenField.value = stepData.labels.join(', ');
            } 
            else {
              hiddenField.value = "";
            }
          });

          // 7) Build data object for Netlify
          const formDataToSend = {
            "form-name": "download",
            "email": email,
            "Recommended Shield Level": recommendedLevel
          };

          // Also gather each hidden field’s name + final .value
          const allHiddenFields = downloadForm.querySelectorAll('input[type="hidden"]');
          allHiddenFields.forEach(field => {
            const fieldName = field.getAttribute('name'); 
            const fieldValue = field.value || "";
            if (fieldName !== "form-name") {
              formDataToSend[fieldName] = fieldValue;
            }
          });

          // 8) Send to Netlify behind-the-scenes
          submitToNetlify(formDataToSend)
            .then(() => {
              console.log("Successfully sent to Netlify! Check your email notifications.");
            })
            .catch((err) => {
              console.error("Error sending data to Netlify:", err);
            });
        });
      }
    } // end if (stepTriggers && stepTargets && quizSteps)
  }

  // Finally, run our quiz initialization
  initializeQuiz();

});